export default __webpack_public_path__ + "static/media/tcsbg.e0808492.jpeg";